import React from 'react';
import PageTemplate from './pages/Encapsulation';
import PrivateRoute from '../../auth/PrivateRoute';


const registerRoutes = {
  home: {
    path: '/home',
    element: <PrivateRoute element={<PageTemplate />} />
  }
};

export default registerRoutes;
